import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui/UiButton';

import cls from './ManagerCardList.module.css';
import { useManagerCardList } from './useManagerCardList';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { ContactPerson } from '../../../../types/dashboardInformation';
import { ManagerCard } from '../ManagerCard/ManagerCard';
import { NotGivenRow } from '../NotGivenRow/NotGivenRow';

interface ManagerCardListProps {
    classes?: string;
}

export const ManagerCardList = ({ classes }: ManagerCardListProps) => {
    const { onShowManagerInfo, onAddManager, contactPerson, is_customer, can_show_financial_info } =
        useManagerCardList();

    const { t } = useTranslation();
    return (
        <div className={classNames(cls.ManagerCardList, [classes])}>
            {contactPerson.map((manager: ContactPerson, index) => (
                <ManagerCard
                    key={manager.id}
                    name={manager.name}
                    src={manager.preview_url}
                    id={manager.id}
                    onClick={onShowManagerInfo}
                    needComa={index !== contactPerson.length - 1}
                />
            ))}
            {!contactPerson.length && !is_customer && can_show_financial_info && (
                <UiButton
                    className={cls.buttonEmptyInfo}
                    onClick={onAddManager}
                    variant="text"
                    startIcon={<Icon iconName="plus" />}
                    btnText={t('button.add.text')}
                    btnTextStyles={cls.emptyText}
                />
            )}
            {!contactPerson.length && (is_customer || !can_show_financial_info) && <NotGivenRow />}
        </div>
    );
};
